// extracted by mini-css-extract-plugin
module.exports = {"vSpacing":"8px","vButtonBorderRadius":"1px","buttonGroup":"ButtonGroup__buttonGroup___5AFru","segmented":"ButtonGroup__segmented___hF6V8","item":"ButtonGroup__item___eJRhH"};